import {helper} from './helper';
import moment from 'moment'

Vue.prototype.moment = moment;
Vue.prototype.$helper = helper;

import store from "./store";
const app = new Vue({
    el: '#app',
    store,
});